import { schema } from 'normalizr';

const permitSchema = new schema.Entity('permits');
const scheduledProposalSchema = new schema.Entity('scheduledProposals');
const reportSystemsSchema = new schema.Entity('reportSystems');
const orderInspectionSchema = new schema.Entity('orderInspections');
const orderStakeholderSchema = new schema.Entity('orderStakeholders');
const orderUnitsSchema = new schema.Entity('orderUnits');

const propertySchema = new schema.Entity('properties', {
  permits: [permitSchema],
});

const orderSchema = new schema.Entity('orders', {
  property: propertySchema,
  inspections: [orderInspectionSchema],
  orderStakeholders: [orderStakeholderSchema],
  orderUnits: [orderUnitsSchema],
});

const jobInspectionSchema = new schema.Entity('jobInspections', {
  scheduledProposal: scheduledProposalSchema,
});

const reportSchema = new schema.Entity('reports', {
  reportSystems: [reportSystemsSchema],
});

const jobSchema = new schema.Entity('jobs', {
  order: orderSchema,
  inspections: [jobInspectionSchema],
  reports: [reportSchema],
});

const dataSchema = new schema.Entity('data', {
  jobs: [jobSchema],
});

export const JobsSchema = dataSchema;
